import { useLocation } from "react-router-dom";
import { useState } from "react";

const DiagnosisDetails = ({ diagnosis, onBack }) => {
    return (
        <div className="w-100">
            <button className="submit-btn m-b-20 col-2" onClick={onBack}>← Back to Health Records</button>
            <div className="health-list">
                <h2 className="diagnosis-title">{diagnosis?.diagnosis}</h2>
                <p className="diagnosis-meta">Date: {diagnosis?.date} | Time: {diagnosis?.time}</p>

                <CollapsibleSection title="Vitals">
                    <Vitals vitalsData={diagnosis?.vitals || []} />
                </CollapsibleSection>

                <CollapsibleSection title="Diagnosis & Treatment">
                    <DiagnosisTreatment treatmentData={diagnosis?.diagnosis || []} />
                </CollapsibleSection>

                <CollapsibleSection title="Prescriptions">
                    <Prescriptions prescriptionsData={diagnosis?.prescriptions || []} />
                </CollapsibleSection>

                <CollapsibleSection title="Lab Tests">
                    <LabTests labTestsData={diagnosis?.labTests || []} />
                </CollapsibleSection>

                <CollapsibleSection title="Discharge Note">
                    <p>{diagnosis?.dischargeNote || "No discharge note available."}</p>
                </CollapsibleSection>
            </div>
        </div>
    );
};

const CollapsibleSection = ({ title, children }) => {
    const [open, setOpen] = useState(false);
    return (
        <div className="">
            <div className="health-item flex space-between" onClick={() => setOpen(!open)}>
                <span>{title}</span>
                <span className="toggle-icon">{open ? "−" : "+"}</span>
            </div>
            {open && <div className="section-content">{children}</div>}
        </div>
    );
};

// Dynamic Components for each section
const Vitals = ({ vitalsData }) => (
    <ul className="list">
        {vitalsData.length > 0 ? vitalsData.map((vital, index) => (
            <li key={index}>{vital}</li>
        )) : <li>No vitals recorded</li>}
    </ul>
);

const DiagnosisTreatment = ({ treatmentData }) => (
    console.log(treatmentData),
    <ul className="list">
        {treatmentData ?
            <li >{treatmentData}</li>
            : <li>No treatment details available</li>}
        {/* {treatmentData?.length > 0 ? treatmentData.map((treatment, index) => (
            <li key={index}>{treatment}</li>
        )) : <li>No treatment details available</li>} */}
    </ul>
);

const Prescriptions = ({ prescriptionsData }) => (
    <ul className="list">
        {prescriptionsData.length > 0 ? prescriptionsData.map((prescription, index) => (
            <li key={index}>{prescription}</li>
        )) : <li>No prescriptions available</li>}
    </ul>
);

const LabTests = ({ labTestsData }) => (
    <ul className="list">
        {labTestsData.length > 0 ? labTestsData.map((test, index) => (
            <li key={index}>{test}</li>
        )) : <li>No lab tests recorded</li>}
    </ul>
);

export default DiagnosisDetails;
